// ============================================
// SOLICITUDESDATOSPANEL.JS — "Clientes que completaron sus datos" en Mi Trabajo (Entrega 2, 2026-09-08)
// ============================================
// Aviso al responsable comercial: "Bodegas Alianza completo sus datos" con lo que se creo/actualizo y
// las diferencias; boton para marcar revisado y para abrir la ficha (si el padre da onAbrirCliente).

import React, { useCallback, useEffect, useState } from 'react';
import { ClipboardCheck, Check } from 'lucide-react';
import { API_BASE_CLI, PP, COLOR_OSCURO, COLOR_GRIS, COLOR_GRIS_CLARO, COLOR_BORDE, estiloBotonSecundario, estiloTarjeta } from './helpersClientes';
import { authHeaders as authBase } from '../utils/storage';
const authHeaders = () => ({ ...authBase(), 'Content-Type': 'application/json' });
const fmt = (v) => { if (!v) return '—'; const d = new Date(v); return isNaN(d) ? '—' : `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; };

export default function SolicitudesDatosPanel({ mios = true }) {
  const [avisos, setAvisos] = useState(null);
  const cargar = useCallback(async () => {
    try {
      const r = await fetch(`${API_BASE_CLI}/api/datos-solicitudes/avisos?mios=${mios ? '1' : '0'}`, { headers: authHeaders() });
      if (!r.ok) return;
      const j = await r.json(); if (j.ok) setAvisos(j.avisos || []);
    } catch { /* silencioso */ }
  }, [mios]);
  useEffect(() => { cargar(); }, [cargar]);
  const revisado = async (s) => { try { const r = await fetch(`${API_BASE_CLI}/api/datos-solicitudes/${s.id}/aviso`, { method: 'PATCH', headers: authHeaders() }); if (r.ok) cargar(); } catch { /* */ } };
  if (!avisos || avisos.length === 0) return null;
  return (
    <div style={{ ...estiloTarjeta, fontFamily: PP, borderLeft: '4px solid #1E7A4C' }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: COLOR_OSCURO, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}><ClipboardCheck size={18} color="#1E7A4C" /> Clientes que completaron sus datos ({avisos.length})</div>
      <div style={{ display: 'grid', gap: 6 }}>
        {avisos.map(s => (
          <div key={s.id} style={{ padding: '8px 10px', borderRadius: 10, border: `1px solid ${COLOR_BORDE}`, background: '#F3FBF6', fontSize: 13, color: COLOR_GRIS }}>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
              <span style={{ flex: '1 1 240px' }}><strong style={{ color: COLOR_OSCURO }}>{s.cliente_nombre}</strong> completó sus datos ({s.nivel_nombre}) el {fmt(s.completado_at)}.</span>
              <button type="button" style={{ ...estiloBotonSecundario, minHeight: 40, display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12 }} onClick={() => revisado(s)}><Check size={14} /> Revisado</button>
            </div>
            {s.aplicado && (
              <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginTop: 4, lineHeight: 1.6 }}>
                {s.aplicado.creado ? 'Se creó la razón social ' : 'Se actualizó la razón social '}<strong style={{ color: COLOR_GRIS }}>{s.aplicado.razon_social ? s.aplicado.razon_social.nombre : ''}</strong>
                {(s.aplicado.diferencias || []).length ? ` · ${s.aplicado.diferencias.length} cambios: ${s.aplicado.diferencias.map(d => d.campo).join(', ')}` : ''}
                {(s.aplicado.documentos || []).length ? ` · ${s.aplicado.documentos.length} documentos adjuntos` : ''}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
